/* Vixxa Atelier — tema davranışları (bağımlılık yok) */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const V = window.Vixxa || {};
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Para biçimi ---------- */
  const money = (cents) => {
    const fmt = V.money || '{{amount_with_comma_separator}} ₺';
    const n = (cents / 100);
    const withComma = n.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const noDec = n.toLocaleString('tr-TR', { maximumFractionDigits: 0 });
    return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, noDec)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec)
      .replace(/\{\{\s*amount\s*\}\}/, withComma);
  };

  /* ---------- Toast ---------- */
  let toastTimer;
  const toast = (msg) => {
    const t = $('#Toast'); if (!t) return;
    t.textContent = msg; t.classList.add('is-visible');
    clearTimeout(toastTimer); toastTimer = setTimeout(() => t.classList.remove('is-visible'), 2600);
  };

  /* ---------- Çekmeceler & modallar ---------- */
  let lastFocus = null;
  const openDrawer = (id) => {
    const d = document.getElementById(id); if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    $$(`[aria-controls="${id}"]`).forEach(b => b.setAttribute('aria-expanded', 'true'));
    const f = d.querySelector('button, a, input, select'); f && f.focus({ preventScroll: true });
  };
  const closeDrawer = (d) => {
    if (!d) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open') && !$('.modal.is-open') && !$('.lightbox.is-open')) document.body.classList.remove('no-scroll');
    $$(`[aria-controls="${d.id}"]`).forEach(b => b.setAttribute('aria-expanded', 'false'));
    lastFocus && lastFocus.focus && lastFocus.focus({ preventScroll: true });
  };
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.dataset.drawerOpen); return; }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) { closeDrawer(closer.closest('.drawer')); return; }
    const mo = e.target.closest('[data-modal-open]');
    if (mo) { const m = document.getElementById(mo.dataset.modalOpen); if (m) { lastFocus = mo; m.classList.add('is-open'); document.body.classList.add('no-scroll'); const c = m.querySelector('[data-modal-close].icon-btn'); c && c.focus(); } return; }
    const mc = e.target.closest('[data-modal-close]');
    if (mc) { const m = mc.closest('.modal'); m.classList.remove('is-open'); if (!$('.drawer.is-open')) document.body.classList.remove('no-scroll'); lastFocus && lastFocus.focus(); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const lb = $('.lightbox.is-open'); if (lb) { closeLightbox(); return; }
    const m = $('.modal.is-open'); if (m) { m.classList.remove('is-open'); document.body.classList.remove('no-scroll'); return; }
    $$('.drawer.is-open').forEach(closeDrawer);
  });

  /* ---------- Header scroll ---------- */
  const header = $('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* ---------- Sepet ---------- */
  const refreshCart = async (open = true) => {
    try {
      const res = await fetch(`${V.routes.root}?sections=cart-drawer`, { headers: { 'Accept': 'application/json' } });
      const data = await res.json();
      const html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
      const fresh = html.querySelector('[data-cart-drawer-inner]');
      const cur = $('[data-cart-drawer-inner]');
      if (fresh && cur) cur.replaceWith(fresh);
      const cart = await (await fetch(`${V.routes.cart}.js`)).json();
      $$('[data-cart-count]').forEach(el => { el.textContent = cart.item_count || ''; el.dataset.count = cart.item_count; });
      if (open) openDrawer('CartDrawer');
    } catch (err) { console.error('[Vixxa] cart refresh', err); }
  };
  /* Sepete uçuş efekti: kaynak görselden header sepet ikonuna */
  const cartIcon = () => $$('a[data-drawer-open="CartDrawer"]').find(a => a.offsetParent !== null && a.getBoundingClientRect().width > 0);
  const bumpCart = () => { const c = cartIcon(); if (!c) return; c.classList.remove('cart-bump'); void c.offsetWidth; c.classList.add('cart-bump'); };
  const flyToCart = (srcImg) => new Promise((resolve) => {
    const target = cartIcon();
    if (!srcImg || !target || reduceMotion || !srcImg.animate) { resolve(); return; }
    const s = srcImg.getBoundingClientRect(), t = target.getBoundingClientRect();
    if (!s.width || s.bottom < 0 || s.top > innerHeight) { resolve(); return; }
    const w = Math.min(s.width, 180), h = w * (s.height / s.width);
    const x0 = s.left + (s.width - w) / 2, y0 = s.top + (s.height - h) / 2;
    const clone = document.createElement('img');
    clone.src = srcImg.currentSrc || srcImg.src; clone.alt = ''; clone.className = 'fly-img';
    Object.assign(clone.style, { left: x0 + 'px', top: y0 + 'px', width: w + 'px', height: h + 'px' });
    document.body.appendChild(clone);
    const dx = t.left + t.width / 2 - (x0 + w / 2), dy = t.top + t.height / 2 - (y0 + h / 2);
    const lift = Math.min(120, Math.abs(dy) * .35 + 40);
    const anim = clone.animate([
      { transform: 'translate(0,0) scale(1) rotate(0deg)', opacity: 1, borderRadius: '6px' },
      { transform: `translate(${dx * .45}px, ${dy * .45 - lift}px) scale(.55) rotate(-8deg)`, opacity: 1, offset: .45, borderRadius: '30%' },
      { transform: `translate(${dx}px, ${dy}px) scale(.08) rotate(0deg)`, opacity: .35, borderRadius: '50%' }
    ], { duration: 820, easing: 'cubic-bezier(.45,.05,.35,1)', fill: 'forwards' });
    let done = false; const fin = () => { if (done) return; done = true; clone.remove(); bumpCart(); resolve(); };
    anim.onfinish = fin; setTimeout(fin, 1100); // arka planda/animasyon kısıtlıysa takılmasın
  });
  const addToCart = async (id, qty = 1, btn, opts = {}) => {
    const { open = true, img = null } = opts;
    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
    try {
      const res = await fetch(`${V.routes.cart_add}.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(qty) }] })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || V.strings.error);
      const flight = flyToCart(img);
      await Promise.all([flight, refreshCart(false)]);
      if (open) openDrawer('CartDrawer');
      toast(V.strings.added);
      try { window.fbq && window.fbq('track', 'AddToCart'); } catch (e) {}
      return true;
    } catch (err) { toast(err.message || V.strings.error); return false; }
    finally { if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; } }
  };
  const cardImg = (el) => {
    const card = el.closest('[data-product-card], .cup__item, .pair__item, .goldcard');
    if (!card) return null;
    const imgs = $$('img', card).filter(i => i.getBoundingClientRect().width > 0);
    return imgs.find(i => { const r = i.getBoundingClientRect(); return r.left >= -2 && r.right <= innerWidth + 2; }) || imgs[0] || null;
  };
  // Kart beden paneli
  document.addEventListener('click', (e) => {
    const op = e.target.closest('[data-card-sizes-open]');
    if (op) {
      e.preventDefault();
      const panel = op.closest('[data-product-card]')?.querySelector('[data-card-sizes]');
      $$('[data-card-sizes].is-open').forEach(p => p !== panel && p.classList.remove('is-open'));
      if (panel) { panel.classList.toggle('is-open'); const f = panel.querySelector('.card__size:not(:disabled)'); panel.classList.contains('is-open') && f && f.focus({ preventScroll: true }); }
      return;
    }
    const cl = e.target.closest('[data-card-sizes-close]');
    if (cl) { cl.closest('[data-card-sizes]').classList.remove('is-open'); return; }
    if (!e.target.closest('[data-card-sizes]')) $$('[data-card-sizes].is-open').forEach(p => p.classList.remove('is-open'));
  });
  document.addEventListener('click', async (e) => {
    const qa = e.target.closest('[data-quick-add]');
    if (qa) {
      e.preventDefault();
      let id = qa.dataset.quickAdd;
      const sel = qa.closest('.pair__item')?.querySelector('[data-pair-select]');
      if (sel) id = sel.value;
      const inDrawer = !!qa.closest('[data-cart-drawer]');
      if (document.body.classList.contains('template-cart') && !inDrawer) { await addToCart(id, 1, qa, { open: false, img: cardImg(qa) }); window.location.reload(); return; }
      const card = qa.closest('[data-product-card]');
      if (card) {
        const ok = await addToCart(id, 1, qa, { open: false, img: cardImg(qa) });
        const panel = card.querySelector('[data-card-sizes]'); panel && panel.classList.remove('is-open');
        const cta = card.querySelector('.card__cta span');
        if (ok && cta) { const b = cta.parentElement, txt = cta.textContent; b.classList.add('is-added'); cta.textContent = 'Sepete eklendi ✓'; setTimeout(() => { b.classList.remove('is-added'); cta.textContent = txt; }, 1800); }
        return;
      }
      addToCart(id, 1, qa, { open: !inDrawer, img: inDrawer ? null : cardImg(qa) }); return;
    }
    const lc = e.target.closest('[data-line-change]');
    if (lc) {
      e.preventDefault(); lc.disabled = true;
      try {
        await fetch(`${V.routes.cart_change}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: lc.dataset.lineChange, quantity: Number(lc.dataset.qtyTo) }) });
        if (document.body.classList.contains('template-cart') && !lc.closest('[data-cart-drawer]')) { window.location.reload(); return; }
        await refreshCart(false);
      } catch (err) { toast(V.strings.error); }
    }
  });
  // Header sepet ikonu: çekmeceyi aç (JS yoksa /cart'a gider)
  $$('a[data-drawer-open="CartDrawer"]').forEach(a => a.addEventListener('click', (e) => { e.preventDefault(); openDrawer('CartDrawer'); }));

  /* ---------- Ürün sayfası ---------- */
  const product = $('[data-product]');
  if (product) {
    const json = JSON.parse($('[data-product-json]').textContent);
    const form = $('#ProductForm');
    const idInput = $('[data-variant-id]', form);
    const addBtn = $('[data-add-btn]', form);
    const qtyInput = $('input[name="quantity"]', form);
    const priceWrap = $('[data-product-price]');
    const stickyPrice = $('[data-sticky-price]');
    const track = $('[data-gallery-track]');
    const slides = $$('.gallery__slide', track);
    const thumbs = $$('[data-thumb]');
    const counter = $('[data-counter]');

    const renderPrice = (v) => {
      let html = `<div class="price price--large"><span class="price__current">${money(v.price)}</span>`;
      if (v.compare > v.price) html += `<s class="price__compare">${money(v.compare)}</s><span class="price__save">%${Math.round((v.compare - v.price) * 100 / v.compare)} indirim</span>`;
      html += '</div>';
      priceWrap.innerHTML = html;
      if (stickyPrice) stickyPrice.innerHTML = html.replace('price--large', '');
    };
    const deskMQ = window.matchMedia('(min-width: 990px)');
    const goTo = (i, smooth = true, reveal = false) => {
      if (!slides[i]) return;
      if (deskMQ.matches) {
        // Masaüstü: görseller ızgarada; istenirse o kareye kaydır ve vurgula
        if (reveal) {
          const s = slides[i].classList.contains('gallery__slide--extra') ? null : slides[i];
          if (!s) { openLightbox(i); return; }
          s.scrollIntoView({ behavior: smooth && !reduceMotion ? 'smooth' : 'auto', block: 'center' });
          s.classList.remove('is-flash'); void s.offsetWidth; s.classList.add('is-flash');
        }
        return;
      }
      track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth && !reduceMotion ? 'smooth' : 'auto' });
    };
    const selected = () => $$('.option', form).map(fs => { const c = $('input:checked', fs); return c ? c.value : null; });
    const onOptionChange = () => {
      const opts = selected();
      $$('.option', form).forEach((fs, i) => { const s = $('[data-option-selected]', fs); if (s) s.textContent = opts[i] || 'Seçiniz'; if (opts[i]) fs.classList.remove('is-missing'); });
      // Uygun olmayan kombinasyonları işaretle
      $$('.option', form).forEach((fs, i) => {
        $$('.swatch-input', fs).forEach(inp => {
          const test = opts.slice(); test[i] = inp.value;
          const ok = json.variants.some(v => v.available && v.options.every((o, k) => test[k] == null || o === test[k]));
          inp.nextElementSibling.classList.toggle('is-unavailable', !ok);
        });
      });
      const v = json.variants.find(v => v.options.every((o, k) => o === opts[k]));
      const bn0 = $('[data-buy-now]', form);
      if (!v) { addBtn.disabled = false; addBtn.dataset.needSize = '1'; addBtn.textContent = V.strings.add; if (bn0) bn0.disabled = false; return; }
      delete addBtn.dataset.needSize;
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? V.strings.add : V.strings.soldOut;
      const bn = $('[data-buy-now]', form); if (bn) bn.disabled = !v.available;
      renderPrice(v);
      if (v.media !== null && v.media !== undefined) goTo(v.media);
      const url = new URL(window.location.href); url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    };
    $$('.swatch-input', form).forEach(i => i.addEventListener('change', onOptionChange));
    if ($('.option', form)) onOptionChange();

    $$('[data-qty]', form).forEach(b => b.addEventListener('click', () => {
      const n = Math.min(10, Math.max(1, (parseInt(qtyInput.value, 10) || 1) + Number(b.dataset.qty)));
      qtyInput.value = n;
    }));
    // Beden seçilmeden sepete/ödemeye geçilmesin
    const needSize = () => {
      if (!addBtn.dataset.needSize) return false;
      const fs = $$('.option', form).find(f => !$('input:checked', f));
      if (fs) { fs.classList.remove('is-missing'); void fs.offsetWidth; fs.classList.add('is-missing'); fs.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' }); }
      toast(V.strings.selectSize); return true;
    };
    // Hemen al: sepete ekle ve doğrudan ödemeye geç
    const buyNow = $('[data-buy-now]', form);
    if (buyNow) buyNow.addEventListener('click', async () => {
      if (needSize()) return;
      if (addBtn.disabled) { toast(V.strings.selectSize); return; }
      buyNow.classList.add('is-loading'); buyNow.disabled = true;
      try {
        const res = await fetch(`${V.routes.cart_add}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: Number(qtyInput.value) }] }) });
        if (!res.ok) { const d = await res.json(); throw new Error(d.description || V.strings.error); }
        try { window.fbq && window.fbq('track', 'AddToCart'); } catch (e) {}
        window.location.href = '/checkout';
      } catch (err) { toast(err.message || V.strings.error); buyNow.classList.remove('is-loading'); buyNow.disabled = false; }
    });
    // Masaüstü: bilgi sütunu uzun olsa da alt kısmı görünür kalsın (sticky, alttan hizalı)
    const infoInner = $('.product__info-inner');
    const fitSticky = () => {
      if (!infoInner) return;
      if (!deskMQ.matches) { infoInner.style.top = ''; return; }
      const head = 88, h = infoInner.offsetHeight, vh = window.innerHeight;
      infoInner.style.top = (h + head + 24 > vh ? vh - h - 24 : head) + 'px';
    };
    fitSticky(); window.addEventListener('resize', fitSticky);
    $$('.accordion details', product).forEach(d => d.addEventListener('toggle', fitSticky));
    if ('ResizeObserver' in window && infoInner) new ResizeObserver(fitSticky).observe(infoInner);

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      if (needSize()) return;
      if (addBtn.disabled) { toast(V.strings.selectSize); return; }
      const gImg = $$('.gallery img, [data-gallery] img', product).find(i => { const r = i.getBoundingClientRect(); return r.width > 0 && r.left >= -2 && r.right <= innerWidth + 2 && r.bottom > 0 && r.top < innerHeight; });
      addToCart(idInput.value, qtyInput.value, addBtn, { open: true, img: gImg || null });
    });

    // Galeri: sayaç + küçük resimler
    if (track && slides.length) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach(en => {
          if (en.isIntersecting && en.intersectionRatio > .6) {
            const i = Number(en.target.dataset.slide);
            if (counter) counter.textContent = i + 1;
            thumbs.forEach(t => t.setAttribute('aria-current', String(Number(t.dataset.thumb) === i)));
          }
        });
      }, { root: track, threshold: [.6] });
      slides.forEach(s => io.observe(s));
      thumbs.forEach(t => t.addEventListener('click', () => goTo(Number(t.dataset.thumb))));
      track.addEventListener('keydown', (e) => {
        const cur = Number(counter ? counter.textContent : 1) - 1;
        if (e.key === 'ArrowRight') goTo(Math.min(slides.length - 1, cur + 1));
        if (e.key === 'ArrowLeft') goTo(Math.max(0, cur - 1));
      });

      // Masaüstü hover zoom (imleci takip eder)
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        slides.forEach(s => {
          const img = $('img', s); if (!img) return;
          s.addEventListener('mouseenter', () => s.classList.add('is-zooming'));
          s.addEventListener('mouseleave', () => { s.classList.remove('is-zooming'); img.style.removeProperty('--zx'); });
          s.addEventListener('mousemove', (e) => {
            const r = s.getBoundingClientRect();
            img.style.setProperty('--zx', `${((e.clientX - r.left) / r.width) * 100}%`);
            img.style.setProperty('--zy', `${((e.clientY - r.top) / r.height) * 100}%`);
          });
        });
      }
      // Tıkla → tam ekran lightbox
      slides.forEach(s => s.addEventListener('click', () => openLightbox(Number(s.dataset.slide))));
    }

    // Önceki / sonraki okları
    const curIndex = () => Number(counter ? counter.textContent : 1) - 1;
    const prevBtn = $('[data-gallery-prev]'), nextBtn = $('[data-gallery-next]');
    if (prevBtn) prevBtn.addEventListener('click', () => goTo(Math.max(0, curIndex() - 1)));
    if (nextBtn) nextBtn.addEventListener('click', () => goTo(Math.min(slides.length - 1, curIndex() + 1)));

    // Set parçası → ilgili görsel
    $$('[data-goto]').forEach(b => b.addEventListener('click', () => {
      const i = Number(b.dataset.goto);
      goTo(i, true, true);
      $$('[data-goto]').forEach(x => x.classList.toggle('is-active', x === b));
      if (window.matchMedia('(max-width: 989px)').matches) track.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    }));

    // Tahmini teslim tarihi (1–2 iş günü kargoya + 1–3 iş günü yol = 2–5 iş günü; Pazar hariç)
    const dr = $('[data-delivery-range]');
    if (dr) {
      const addBiz = (d, n) => { const x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (x.getDay() !== 0 && x.getDay() !== 6) n--; } return x; };
      const f = (d) => d.toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', weekday: 'short' });
      const now = new Date();
      dr.textContent = `${f(addBiz(now, 2))} – ${f(addBiz(now, 5))}`;
    }

    // Sticky ATC
    const sticky = $('[data-sticky-atc]');
    if (sticky && addBtn) {
      const obs = new IntersectionObserver(([en]) => {
        const show = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show); sticky.setAttribute('aria-hidden', String(!show));
      });
      obs.observe(addBtn);
      $('[data-sticky-add]', sticky).addEventListener('click', () => {
        if (needSize()) return;
        if (addBtn.disabled) { addBtn.scrollIntoView({ behavior: 'smooth', block: 'center' }); toast(V.strings.selectSize); return; }
        addToCart(idInput.value, qtyInput.value, $('[data-sticky-add]', sticky));
      });
    }
  }

  /* ---------- Lightbox (pinch / çift dokunma / tıkla yakınlaştır) ---------- */
  const lb = $('[data-lightbox]');
  let lbBuilt = false;
  function openLightbox(index = 0) {
    if (!lb) return;
    const scroller = $('[data-lightbox-scroller]', lb);
    if (!lbBuilt) {
      $$('.gallery__slide[data-zoom-src]').forEach((s) => {
        const item = document.createElement('div'); item.className = 'lightbox__item';
        const img = document.createElement('img'); img.loading = 'lazy'; img.src = s.dataset.zoomSrc; img.alt = $('img', s)?.alt || '';
        img.addEventListener('click', (e) => {
          const zoomed = item.classList.toggle('is-zoomed');
          if (zoomed) {
            const r = img.getBoundingClientRect(); const px = (e.clientX - r.left) / r.width; const py = (e.clientY - r.top) / r.height;
            requestAnimationFrame(() => { item.scrollLeft = item.scrollWidth * px - item.clientWidth / 2; item.scrollTop = item.scrollHeight * py - item.clientHeight / 2; });
          }
        });
        item.appendChild(img); scroller.appendChild(item);
      });
      lbBuilt = true;
    }
    lb.classList.add('is-open'); document.body.classList.add('no-scroll');
    requestAnimationFrame(() => { scroller.scrollLeft = scroller.clientWidth * index; });
    $('[data-lightbox-close]', lb).focus();
  }
  function closeLightbox() {
    if (!lb) return;
    lb.classList.remove('is-open'); $$('.lightbox__item', lb).forEach(i => i.classList.remove('is-zoomed'));
    if (!$('.drawer.is-open')) document.body.classList.remove('no-scroll');
  }
  if (lb) {
    $('[data-lightbox-close]', lb).addEventListener('click', closeLightbox);
    const sc = $('[data-lightbox-scroller]', lb);
    $('[data-lightbox-prev]', lb).addEventListener('click', () => sc.scrollBy({ left: -sc.clientWidth, behavior: 'smooth' }));
    $('[data-lightbox-next]', lb).addEventListener('click', () => sc.scrollBy({ left: sc.clientWidth, behavior: 'smooth' }));
  }

  /* ---------- Koleksiyon: sıralama ve filtre ---------- */
  const sort = $('[data-sort]');
  if (sort) sort.addEventListener('change', () => sort.form.submit());

  /* ---------- Benzer ürünler (lazy) ---------- */
  const rel = $('[data-related]');
  if (rel && rel.dataset.url) {
    const io = new IntersectionObserver(async ([en], o) => {
      if (!en.isIntersecting) return; o.disconnect();
      try { const html = await (await fetch(rel.dataset.url)).text(); const d = new DOMParser().parseFromString(html, 'text/html'); const n = d.querySelector('[data-related]'); if (n && n.innerHTML.trim()) rel.innerHTML = n.innerHTML; } catch (e) {}
    }, { rootMargin: '400px' });
    io.observe(rel);
  }

  /* ---------- Paketlerimiz: tek tıkla paket ---------- */
  $$('[data-pack]').forEach(pack => {
    const btn = $('[data-pack-add]', pack);
    const selects = $$('[data-pack-select]', pack);
    const disc = Number(pack.dataset.disc || 0);
    const recalc = () => {
      let total = 0;
      selects.forEach(s => {
        const opt = s.tagName === 'SELECT' ? (s.selectedOptions[0] && s.value ? s.selectedOptions[0] : s.querySelector('option[data-price]:not([disabled])')) : s;
        total += Number((opt && opt.dataset.price) || 0);
      });
      const was = $('[data-pack-was]', pack), now = $('[data-pack-now]', pack);
      if (was) was.textContent = money(total);
      if (now) now.textContent = money(Math.max(0, total - disc));
    };
    selects.forEach(s => s.addEventListener('change', () => { s.classList.remove('is-missing'); recalc(); }));
    btn && btn.addEventListener('click', async () => {
      const missing = selects.filter(s => s.tagName === 'SELECT' && !s.value);
      if (missing.length) { missing.forEach(s => s.classList.add('is-missing')); missing[0].focus(); toast('Paketteki ürünler için beden seçin'); return; }
      btn.classList.add('is-loading'); btn.disabled = true;
      try {
        const items = selects.map(s => ({ id: Number(s.value), quantity: 1 }));
        const res = await fetch(`${V.routes.cart_add}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items }) });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || V.strings.error);
        await refreshCart(true); toast('Paket sepete eklendi');
        try { window.fbq && window.fbq('track', 'AddToCart'); } catch (e) {}
      } catch (err) { toast(err.message || V.strings.error); }
      finally { btn.classList.remove('is-loading'); btn.disabled = false; }
    });
  });

  /* ---------- Set vitrini: parçaya tıkla, görsel değişsin ---------- */
  $$('[data-fset]').forEach(fs => {
    const img = $('.fset__main img', fs);
    $$('[data-fset-src]', fs).forEach(b => b.addEventListener('click', () => {
      if (!img) return;
      img.removeAttribute('srcset'); img.src = b.dataset.fsetSrc;
      $$('.fset__piece', fs).forEach(x => x.classList.toggle('is-active', x === b));
    }));
  });

  /* ---------- Ürün kartı: dokunmatikte nokta göstergesi ---------- */
  $$('.card__media--swipe').forEach(m => {
    const dots = $$('.card__dots i', m); if (!dots.length) return;
    m.addEventListener('scroll', () => { const i = Math.round(m.scrollLeft / m.clientWidth); dots.forEach((d, k) => d.style.background = k === i ? '#fff' : 'rgba(255,255,255,.6)'); }, { passive: true });
  });
})();
